module.exports = __webpack_public_path__ + "static/media/skills.cd63afc7.png";